export default __webpack_public_path__ + "static/Plots0103-ac2a2df4521375c0a16adfa8b524abbf.jpg";